
















































































































































































import {Component, Ref} from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import StickyButton from '@/components/common/StickyButton.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import {ElForm} from 'element-ui/types/form'
import {getPlotParams, resultPlot} from "@/request/apis/GeneSetEnrichmentRequest"
import Gallery from "@/components/common/Gallery.vue"
import {getSocket} from "@/socket.io"
import DropdownGroup from "@/components/common/DropdownGroup.vue"
import {addTimeStamp} from "@/utils/util";

@Component({
  components: {
    Gallery,
    DropdownGroup,
    StickyButton,
    ResultWrapper,
    ModuleWrapper,
    ModuleIntroduction
  }
})

export default class GeneSetEnrichmentResult extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('dropdown') readonly dropdown!: DropdownGroup

  private pathwayList: any[] = []
  private pathwayNames: any[] = []
  private groupAnnotationList: any[] = []
  private plotTypeList: any[] = ['umap', 'tsne', 'both']
  private plotFigure: any = {
    checkedPathway: [],
    groupAnnotation: '',
    plotType: 'umap',
    checkAll: false,
    isIndeterminate: true
  }
  private heatmapUrl: string = ''
  private thumbList: any[] = []
  private thumbName: any[] = []
  private imgDownloadUrl: string = ''
  private currentIndex: number = 0
  private loadingProcessButton: boolean = false
  private MIN: number = 0
  private MAX: number = 1
  private score_slider: any = {
    value: [this.MIN, this.MAX],
    marks: {
      0: '0',
      0.5: '0.5',
      1: '1'
    }
  }
  private counts_slider: any = {
    th: [5, 1000],
    value: 5,
    marks: {
      5: '5'
    }
  }

  get id() {
    return this.$route.params.id
  }

  get displayCheckedPathway () {
    if (this.plotFigure.checkedPathway.length > 100) {
      return 'Pathway List (top 100): '+ this.plotFigure.checkedPathway.slice(0, 100).join('; ');
    }
    return this.plotFigure.checkedPathway.join('; ');
  }


  private handleCheckAllChange(val: boolean) {
    this.plotFigure.checkedPathway = val ? this.pathwayNames : []
    this.plotFigure.isIndeterminate = false
  }

  private handleCheckedValueChange(value: string[]) {
    let checkedCount = value.length
    this.plotFigure.checkAll = checkedCount === this.pathwayNames.length
    this.plotFigure.isIndeterminate = checkedCount > 0 && checkedCount < this.pathwayNames.length
  }

  /**
   * 根据score过滤 pathway数组
   */
  private async filterPathwayList() {
    if (!this.pathwayNames) return
    this.pathwayNames = this.pathwayList.reduce((pre, item) => {
      if (item.enrichment_score >= this.score_slider.value[0] && item.enrichment_score <= this.score_slider.value[1] && item.gene_counts >= this.counts_slider.value) {
        return [...pre, item.pathway_name]
      } else return pre
    }, [])
    this.plotFigure.checkAll = false
    this.plotFigure.isIndeterminate = true
    this.plotFigure.checkedPathway = []
  }

  /**
   * 表单提交
   */
  private submitHandler() {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            job_id: this.id,
            pathway_names: this.plotFigure.checkedPathway,
            group_annotation: this.plotFigure.groupAnnotation,
            plot_type: this.plotFigure.plotType
          }
          await resultPlot(null, params).start()
        } catch (e) {
          console.warn(e)
        }
      } else {
        return false
      }
    })
  }

  /**
   * 监听 websocket 消息
   */
  private async addSocketListener() {
    await this.$nextTick()
    const socket = getSocket()
    if (!socket) return
    socket.on('plot_finish', (res: any) => {
      const result = res.data
      if (result.job_id !== this.id) return // 如果更新的不是此任务就return
      this.loadingProcessButton = false
      this.dropdown.getDownloadData(this.id)
      if (result.status === 'error') {
        this.$notify.error({
          title: '提示',
          message: '图像生成失败',
          offset: 90,
          duration: 10000
        });
        return
      }
      // url相同时 img不更新, 拼接参数重新读取
      this.heatmapUrl = result.heatmap_url + '?' + (new Date()).getTime()
      this.thumbList = addTimeStamp(result.images)
      this.imgDownloadUrl = result.images_download
      this.thumbName = this.thumbList.map((item: string) => {
        return decodeURIComponent(item.split('/')[item.split('/').length - 1].split('.')[0])
      })
    })
  }

  /**
   * 获取结果数据并显示
   */
  private async getResult() {
    const plotParams = await getPlotParams(null, this.id).start()
    this.pathwayList = plotParams.pathway_list
    // 根据 pathway列表提取 pathway_name
    this.pathwayNames = this.pathwayList.map(item => {
      return item.pathway_name
    })
    this.groupAnnotationList = plotParams.group_annotation
    this.plotFigure.groupAnnotation = this.groupAnnotationList[0]
    // const result = await getResultList(null, this.id).start()
    // this.geneListDownloadUrl = result.gene_list_download
  }

  private get rules() {
    const checkPathway = (rule: any, value: any[], callback: Function) => {
      if (value.length === 0) {
        return callback(new Error(<string>this.$t('form.choose')))
      }
      callback()
    }
    return {
      checkedPathway: [
        {validator: checkPathway, trigger: 'change'}
      ]
    }
  }

  mounted() {
    this.getResult()
    this.addSocketListener()
  }

  destroyed () {
    const socket = getSocket()
    socket.off('plot_finish')
  }
}
